import script from "./agent.vue?vue&type=script&setup=true&lang=ts"
export * from "./agent.vue?vue&type=script&setup=true&lang=ts"

import "./agent.vue?vue&type=style&index=0&id=50c49f42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50c49f42"]])

export default __exports__